<template>
    <div class="mod-rm__trainerinformation">
      <div class="pkg-search-box">
        <!-- 查询区 -->
        <el-form class="pkg-content"
                 :inline="false"
                 :model="dataForm"
                 ref="trainerinformationRef"
                 @submit.native.prevent
                 @keyup.enter.native="queryDataInfo()"
                 label-width="90px">
          <!--查询条件 第一行-->
          <el-row :gutter="0">
            <!--培训师-->
            <el-col :span="7">
              <el-form-item prop="userName"
                            :label="$t('trainer.trainer')">
                <el-input v-model="dataForm.userName"
                          :placeholder="$t('trainer.queryName')"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 所在城市 -->
            <el-col :span="7">
              <el-form-item prop="city"
                            :label="$t('trainer.city')">
                <class-tree ref="cityclassRef"
                            v-on:getSelectList="getcitySelectList"
                            v-bind:defaultProps="citydefaultProps"
                            v-bind:isOpen=false
                            v-bind:url="queryCityTreeUrl"
                            v-bind:isSelect=false
                            v-on:clearTreeInfo="cityclassInfo"
                            v-bind:listName="'city'"></class-tree>
                <!-- <el-input v-model="dataForm.city"
                          :placeholder="$t('trainer.city')"
                          clearable></el-input> -->
              </el-form-item>
            </el-col>
            <!-- 培训师团队分类 -->
            <el-col :span="7">
              <el-form-item prop="groupType"
                            :label="$t('trainer.teamClassification')">
                <class-tree ref="classRef"
                            v-on:getSelectList="getSelectList"
                            v-on:clearTreeInfo="clearTreeInfo"
                            v-bind:listName="'trainser'"
                            v-bind:defaultProps="defaultProps"
                            v-bind:url="queryTreeUrl"
                            v-bind:isSelect=false></class-tree>
                <!-- <el-input v-model="dataForm.groupType"
                          :placeholder="$t('trainer.teamClassification')"
                          clearable></el-input> -->
              </el-form-item>
            </el-col>
            <!-- 查询按钮 -->
            <el-col :span="3"
                    class="query-button">
              <el-col :span="24">
                <!--查询按钮-->
                <el-button class="M-search"
                           style="margin-bottom: 7px"
                           type="primary"
                           v-if="$hasPermission('AUTHTRAINER0001')"
                           @click="queryDataInfo()">{{ $t('trainer.query') }}</el-button>
              </el-col>
            </el-col>
          </el-row>
          <!--查询条件 第二行-->
          <el-row :gutter="0">
            <!-- 培训师角色 -->
            <el-col :span="7">
              <el-form-item prop="trainerRole"
                            :label="$t('trainer.role')">
                <el-select multiple
                           collapse-tags
                           v-model="dataForm.trainerRoleList"
                           :placeholder="$t('res.vehinfo.select')">
                  <el-option v-for="(item,index) in trainerRoleArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
                <!-- <el-input v-model="dataForm.trainerRole"
                          :placeholder="$t('trainer.role')"
                          clearable></el-input> -->
              </el-form-item>
            </el-col>
            <!-- 培训师状态 -->
            <el-col :span="7">
              <el-form-item prop="trainerStatus"
                            :label="$t('trainer.status')">
                <el-select multiple
                           v-model="dataForm.trainerStatusList"
                           :placeholder="$t('res.vehinfo.select')">
                  <el-option v-for="(item,index) in statusArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
                <!-- <el-input v-model="dataForm.trainerStatus"
                          :placeholder="$t('trainer.status')"
                          clearable></el-input> -->
              </el-form-item>
            </el-col>
            <!-- 培训师标签 -->
            <el-col :span="7">
              <!--<el-form-item prop="labelTypeId"-->
                            <!--:label="$t('trainer.Label')">-->
                <!--<el-input v-model="dataForm.labelTypeName"-->
                          <!--@focus="showSuboSiteDlg()"-->
                          <!--:placeholder="$t('trainer.Label')"></el-input>-->
              <!--</el-form-item>-->
              <el-form-item class="search-item" style="height: 34px;">
                <span slot="label">
                  <el-link type="primary" :underline="false" slot="reference"
                           @click.native.prevent="showSuboSiteDlg">{{ $t('trainer.Label')}}</el-link>
                </span>
                <div class="el-input el-input--default el-input__inner el-form-item__content" style="height:30px;" @mouseenter="trainerLabelShow()" @mouseleave="trainerLabelLeave()" >
                  <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.labelTypeName}}</div>
                  <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="templateNameLink" v-show="vehicleLabelShowFlg && dataForm.labelTypeName != '' && dataForm.labelTypeName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="trainerLabelName()"></el-link>
                </div>
              </el-form-item>
            </el-col>
            <!-- 重置按钮 -->
            <el-col :span="3"
                    class="query-button">
              <el-col :span="24">
                <el-button class="el-back M-search M-margin-l"
                           type="info"
                           v-if="$hasPermission('AUTHTRAINER0002')"
                           @click="resetQuery">{{ $t('trainer.reset') }}</el-button>
              </el-col>
            </el-col>
          </el-row>
          <!--查询条件 第三行-->
          <div v-show="moreList">
            <el-row :gutter="0">
              <!-- 组织类型 -->
              <el-col :span="7">
                <el-form-item prop="queryOrgType"
                              :label="$t('trainer.orgType')">
                  <el-select v-model="dataForm.queryOrgType"
                             @change=add
                             :placeholder="$t('res.vehinfo.select')"
                             clearable>
                    <el-option v-for="(item,index) in neworgType"
                               :key="index"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 所属公司 -->
              <el-col :span="7">
                <el-form-item prop="companyList"
                              :label="$t('res.site.company')">
                  <el-select multiple
                             collapse-tags
                             filterable
                             v-model="dataForm.companyList"
                             :placeholder="$t('trainer.companyList')">
                    <el-option v-for="(item,index) in companyList"
                               :key="index"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- <el-input v-model="dataForm.trainerRole"
                            :placeholder="$t('trainer.role')"
                            clearable></el-input> -->
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <el-row style="text-align: center; margin-bottom: 10px;">
          <el-col :span="24">
            <div class="show-or-hide-icon"
                 v-bind:class="{ 'el-icon-arrow-up': moreList,
                                       'el-icon-arrow-down': !moreList }"
                 @click="moreList = !moreList">&nbsp;{{ moreList ? '收起' : '高级搜索' }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pkg-content">
        <!--按钮区-->
        <div class="search">
          <!--新增-->
          <el-button type="primary"
                     v-if="$hasPermission('AUTHTRAINER0003')"
                     @click="addUpdate()">{{ $t('trainer.add') }}</el-button>
          <!-- 导出 -->
          <el-button type="primary"
                     v-if="$hasPermission('AUTHTRAINER0004')"
                     @click="exportHandle()">{{ $t('trainer.export') }}</el-button>
          <el-button type="primary"
                     v-if="$hasPermission('AUTHTRAINERCONTRACT0001')"
                     @click="showUpload()">{{ $t('contract.mutliContractManage') }}</el-button>
        </div>
        <!-- 查询显示列区 -->
        <el-table :data="dataList"
                  border
                  stripe
                  v-loading="dataListLoading"
                  style="width: 100%;">
          <!-- 序号 -->
          <el-table-column type="index"
                           header-align="center"
                           align="center"
                           width="50"
                           :index="indexCreate"
                           :label="$t('trainer.No')">
          </el-table-column>
          <!--用户名-->
          <el-table-column prop="id"
                           header-align="center"
                           align="center"
                           v-if="false"
                           show-overflow-tooltip
                           :label="$t('trainer.UserName')">
          </el-table-column>
          <!--用户ID-->
          <el-table-column prop="userName"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.UserName')">
          </el-table-column>
          <!--员工号-->
          <el-table-column prop="userCardNo"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.userCardNo')">
          </el-table-column>
          <!--培训师姓名-->
          <el-table-column prop="userNameTrain"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.Name')">
          </el-table-column>
          <!--组织类型-->
          <el-table-column prop="orgType"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.orgType')">
          </el-table-column>
          <!--所属公司-->
          <el-table-column prop="company"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.site')">
          </el-table-column>
          <!--所在城市-->
          <el-table-column prop="cityName"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.city')">
          </el-table-column>
          <!--培训师团队分类-->
          <el-table-column prop="groupTypeName"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.teamClassification')">
          </el-table-column>
          <!--培训师状态-->
          <el-table-column prop="trainerStatusName"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.status')">
          </el-table-column>
          <el-table-column header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.Label')">
            <template slot-scope="scope">
              <!--查看-->
              <span class="el-dropdown-link"
                    v-if="scope.row.number !== null"
                    @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
            </template>
          </el-table-column>
          <!--培训师角色-->
          <el-table-column prop="trainerRoleName"
                           header-align="center"
                           align="center"
                           show-overflow-tooltip
                           :label="$t('trainer.role')">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right"
                           align="center"
                           width="120"
                           v-if="$hasPermission('AUTHTRAINER0008') || $hasPermission('AUTHTRAINER0006') || $hasPermission('AUTHTRAINER0007')"
                           :label="$t('handle')">
            <template slot-scope="scope">
              <!--查看-->
              <span class="el-dropdown-link"
                    v-if="$hasPermission('AUTHTRAINER0008')"
                    @click="gotoView('check', scope.row)">{{ $t('res.vehinfo.check') }}</span>
              <!-- 竖线隔开 -->
               <div class="pkg-vertical-divider"></div>
              <el-dropdown trigger="click"
                           placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!--显示不活动按钮-->
                  <el-dropdown-item v-if="scope.row.trainerStatus =='10' && $hasPermission('AUTHTRAINER0006')"
                                    @click.native="gotoView('noActivity', scope.row)">{{ $t('trainer.inactive') }}</el-dropdown-item>
                  <!--显示活动按钮-->
                  <el-dropdown-item v-if="scope.row.trainerStatus =='20' && $hasPermission('AUTHTRAINER0007')"
                                    @click.native="gotoView('activity', scope.row)">{{ $t('trainer.active') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页区 -->
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="dataForm.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="dataForm.limit"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
                           :visible="isShowLable"
                           width="70%"
                           :before-close="showLableClose">
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkLists"
                     :moduleId="moduleId"
                     :overLabelShow = "false"
                     :closeShow = "false"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <!--标签查询条件-->
    <el-dialog title="选择标签"
                 :visible="isQueryShowLable"
                 width="70%"
                 :before-close="showQueryLableClose">
        <el-form label-position="top"
                 label-width="150px"
                 :ref="dataForm"
                 ref="dataForm">
          <div>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="tagName"
                              style="width: 100%!important;">
                  <tag :checkedList="checkList"
                       :moduleId="moduleId"
                       :overLabelShow = "true"
                       :closeShow = "true"
                       :bussinessTypeId = "bussinessTypeId"
                       :brandCode="bussinessTypeChecked"
                       @getBussinessType="getBussinessType"
                       @changeCheckedList="changeCheckedList"
                       ref='tagTree'
                       @fatherMethod="fatherMethod"></tag>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div>
          <el-button type="primary"
                     @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
        </div>
      </el-dialog>
      <contractUploadModal
        v-if="contractShow"
        @closeCancelDlg="closeModal"
      ></contractUploadModal>
  </div>
</template>

<script>
import AddOrUpdate from './trainerinformation-add-or-update'
import ClassTree from '@/components/rm/class-tree/index'
import Tag from '@/components/rm/label-select/index'
import contractUploadModal from './trainerContractBatchUp'
import VueI18n from '@/i18n'

export default {
  components: {
    Tag,
    AddOrUpdate,
    contractUploadModal,
    'class-tree': ClassTree
  },
  data () {
    return {
      checkLists:[],
      typeArr: this.enums['orgType'], // 所属分类
      // 组织类型
      neworgType: [],
      companyList: [],
      // 默认收起多的查询条件
      moreList: false,
      vehicleLabelShowFlg: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 7,
      bussinessTypeChecked: null,
      isShowLable: false,
      isQueryShowLable: false,
      // 团队分类
      groupTypeListArr: this.enums['teaTeamClass'],
      // 培训师状态
      statusArr: this.enums['status'],
      // 培训师角色
      trainerRoleArr: this.enums['trainerRole'],
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTreeUrl: '/rm/rpc/treamClassTree/list',
      // 主页面城市树
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      dataListLoading: false,
      dataList: [],
      total: 0,
      dataForm: {
        userName: '',
        groupType: '',
        trainerRoleList: [],
        trainerStatusList: [],
        labelTypeId: [],
        cityList: [],
        groupTypeList: [],
        labelTypeName: '',
        queryOrgType: '',
        companyList: [],
        page: 1,
        limit: 10
      },
      contractShow: false
    }
  },
  methods: {
    showUpload () {
      this.contractShow = true
    },
    closeModal () {
      this.contractShow = false
    },
    cityclassInfo (listName) {
      if(listName === 'city'){
        this.dataForm.cityList = []
      }
    },
    checkLable(row){
      this.isShowLable = true
      this.$request.get(`/rm/trainer/info`, { trainerId: row.id }).then((res, total, code, data) => {
        // 已选择的标签
        this.checkLists = data.data.commLabelVoList ? data.data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkLists.length; i ++){
            if(this.checkLists[i].labelNameCn !== null){
              this.checkLists[i].labelName = this.checkLists[i].labelNameCn
            }else{
              this.checkLists.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkLists.length; i ++){
            if(this.checkLists[i].labelNameEn !== null){
              this.checkLists[i].labelName = this.checkLists[i].labelNameEn
            }else{
              this.checkLists.splice(i,1)
              i--
            }
          }
        }
      })
    },
    showLableClose(){
      this.isShowLable = false
    },
    showQueryLableClose(){
      this.isQueryShowLable = false
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = val
      this.bussinessTypeId = val
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    },
    // 操作区下拉的方法
    gotoView (type, row) {
      let query = {}
      let name = 'rm-trainerinformation-view'
      query.id = row.id
      if (type === 'check') {
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.TRAINER_INFO, '')
      } else if (type === 'update') {
        query.type = 'updata'
        query.operationType = 'update'
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.VEHICLE_INFO, '')
      } else if (type === 'activity') {
        this.modify(type, row)
      } else if (type === 'noActivity') {
        this.modify(type, row)
      }
    },
    // 修改活动/不活动
    modify (type, row) {
      let tips
      if (type === 'activity') {
        tips = this.$t('trainer.trainerActivityStatus')
      } else if (type === 'noActivity') {
        tips = this.$t('trainer.trainerInactiveStatus')
      }
      this.$confirm(tips, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        row['statusType'] = type
        if (row.trainerStatus === '10') {
          row.trainerStatus = '20'
        } else {
          row.trainerStatus = '10'
        }
        this.$request.post(
          `/rm/trainer/updateTrainerStatus`, row
        ).then((data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.queryDataInfo()
            }
          })
        })
        this.queryDataInfo()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 点击选择标签打开弹窗
    showSuboSiteDlg () {
      this.isQueryShowLable = true
    },
    // 查询按钮
    queryDataInfo () {
      this.dataForm.page = 1
      this.getInfo()
    },
    // 新增方法
    addUpdate () {
      let name = 'rm-trainerinformation-add-or-update'
      this.$router.push({
        name: name
      })
    },
    // 重置查询条件
    resetQuery () {
      this.dataForm = {
        userName: '',
        groupType: '',
        trainerRoleList: [],
        trainerStatusList: [],
        labelTypeId: [],
        cityList: [],
        groupTypeList: [],
        page: 1,
        limit: 10
      }
      this.companyList = []
      this.$refs.cityclassRef.resetChecked()
      this.$refs.classRef.resetChecked()
      this.dataForm.label = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.$refs.tagTree && this.$refs.tagTree.isReset()
      this.getInfo()
    },
    // 主页面查询勾选城市树事件
    getcitySelectList (args) {
      let citySelect = []
      if (args && args.length > 0) {
        args.forEach(function (item) {
          citySelect.push(item.id)
        })
      }
      this.dataForm.cityList = citySelect
    },
    // 团队分类
    getSelectList (args) {
      let tramClass = []
      if (args && args !== '' && args.length > 0) {
        args.forEach(function (item) {
          tramClass.push(item.id)
        })
      }
      this.dataForm.groupTypeList = tramClass
    },
    // 生成网格的序号
    indexCreate (index) {
      return (this.dataForm.page - 1) * this.dataForm.limit + (index + 1)
    },
    // 导出
    exportHandle () {
      let param = JSON.parse(JSON.stringify(this.dataForm))
      this.$request.downloadRm('/rm/trainer/export', '培训师信息', param)
    },
    // 子页面重置按钮触发
    clearTreeInfo (listName) {
      if(listName === 'trainser'){
        this.dataForm.groupTypeList = []
      }
    },
    // 查询
    getInfo () {
      this.dataListLoading = true
      this.$request.post('/rm/trainer/queryPageList', this.dataForm).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = resultList
        this.total = parseInt(data.data.total, 10)
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.dataForm.page = 1
      this.dataForm.limit = val
      this.getInfo()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getInfo()
    },
    onOkLable(){
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let trainerLabelinfo = []
        let trainerLabelinfoName = []
        args.forEach(function (item) {
          trainerLabelinfo.push(item.labelId)
          trainerLabelinfoName.push(item.labelName)
        })
        this.dataForm.labelTypeId = trainerLabelinfo
        this.dataForm.labelTypeName = trainerLabelinfoName.join(',')
      } else {
        this.dataForm.labelTypeId = []
        this.dataForm.labelTypeName = ''
      }
      this.isQueryShowLable = false
    },
    trainerLabelShow () {
      this.vehicleLabelShowFlg = true
    },
    trainerLabelLeave () {
      this.vehicleLabelShowFlg = false
    },
    trainerLabelName () {
      this.dataForm.labelTypeId = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.vehicleLabelShowFlg = false
      this.$refs.tagTree.isReset()
    },
    // 组织类型
    add (value) {
      debugger
      if (value === '' && value === undefined && value === null) {
        this.companyList = []
      }else{
        this.queryCompany(value)
      }
    },
    // 查询公司下拉选
    queryCompany (val) {
      // 获取公司下拉框数据
      if (val !== '' && val !== undefined && val !== null) {
        this.$request.get(`/rm/company/info`, { 'orgTypeList': val }).then((data) => {
          let arr = []
          data.forEach(function (item) {
            let param = { value: item.orgId, label: item.nameCn }
            arr.push(param)
          })
          this.companyList = arr
        })
      }else{
        this.dataForm.companyList = []
        this.companyList = []
      }
    },
  },
  mounted () {
    this.neworgType = JSON.parse(JSON.stringify(this.typeArr))
    if (this.neworgType.length === 6) {
      this.neworgType.splice(4, 1)
    }
    this.getInfo()
  }

}
</script>

<style lang="css" scoped>
@import "../../css/pkg-styles.css";
</style>
